export const CheckFloatValue = (n) => {
  if (n === +n && n !== (n | 0)) {
    return n.toFixed(2);
  } else {
    return n;
  }
};
export const getLocalStorageItem = (key, parseJSON = false) => {
  try {
    const value = localStorage.getItem(key);
    if (!value) return null;
    return parseJSON ? JSON.parse(value) : value;
  } catch (error) {
    console.error(`Error getting localStorage item: ${key}`, error);
    return null;
  }
};
export const setLocalStorageItem = (key, value) => {
  try {
    const storedValue = JSON.stringify(value);
    localStorage.setItem(key, storedValue);
  } catch (error) {
    console.error(`Error setting localStorage item: ${key}`, error);
  }
};
export const getAuthenticated = () => {
  try {
    const tokenData = getLocalStorageItem("userAuthData", true);
    return !!(tokenData && tokenData?.token);
  } catch (error) {
    console.error("Error checking authentication", error);
    return false;
  }
};
export const getAccessTokenSilently = () => {
  try {
    const stored = localStorage.getItem("userAuthData");
    if (!stored) return false;
    const tokenData = JSON.parse(stored);
    return tokenData?.token || false;
  } catch (error) {
    console.error("Error checking authentication", error);
    return false;
  }
};

export const clearLocalStorage = () => {
  try {
    localStorage.clear();
  } catch (error) {
    //
  }
};
export const logout = () => {
  try {
    localStorage.clear();
    window.location.reload();
    window.location.href = "/login";
  } catch (error) {
    //
  }
};
